/**
 * @desc 地址信息
 */
import dPoi from '@/config/countryConfig/default-poi';
import { getCountry } from '@/utils/index';

class Address {
  constructor({ defaultPoi }) {
    this.address = {
      /** @desc 地址信息 **/
      countyId: defaultPoi.countyId,
      countyGroupId: defaultPoi.countyGroupId,
      cityId: defaultPoi?.cityId,
      lat: defaultPoi.lat,
      lng: defaultPoi.lng,
      poiId: defaultPoi.poiId,

      /** @desc 地址未返回的参数 **/
      poiCityId: defaultPoi?.cityId,
      poiCountyId: defaultPoi.countyId,
      poiCountyGroupId: defaultPoi.countyGroupId,
      poiName: defaultPoi.displayName,
      poiLat: defaultPoi.lat,
      poiLng: defaultPoi.lng,
    };
  }
  setAddress(poi = {}) {
    const { cityId, lat, lng } = poi;

    if (cityId && lat && lng) {
      this.address = {
        countyId: +poi.countyId,
        countyGroupId: +poi?.countyGroupId,
        cityId: +cityId,
        lat: +lat,
        lng: +lng,
        poiId: poi.poiId,
        poiCityId: +(poi?.poiCityId || poi?.cityId),
        poiCountyId: +(poi?.poiCountyId || poi?.countyId),
        poiCountyGroupId: +(poi?.poiCountyGroupId || poi?.countyGroupId),
        poiName: poi?.poiName || poi?.displayName,
        poiLat: +(poi?.poiLat || poi?.lat),
        poiLng: +(poi?.poiLng || poi?.lng),
      };
    }
  }
  getAddress() {
    return this.address;
  }
}

const country = getCountry();
const defaultPoi = dPoi.getPoi(country); // 默认地址
const address = new Address({ defaultPoi });
export default address;
